module.exports = __webpack_public_path__ + "media/images/logo60-75f4d40fcc8a51d7e211ca9018f9ba54.png";